import { CommonModule, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatDialogModule } from '@angular/material/dialog';
// import { DataTablesModule } from 'angular-datatables';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { NgxMaskModule } from 'ngx-mask';
import { AppRoutingModule } from '../app.routing';
import { CarepathreadyComponent } from './carepathready/carepathready.component';
import { CodeComponent } from './code/code.component';
import { CreatecarepasswordComponent } from './createcarepassword/createcarepassword.component';
import { CreatenewpasswordComponent } from './createnewpassword/createnewpassword.component';
import { HelpdeskComponent } from './helpdesk/helpdesk.component';
import { IntropageComponent } from './Intropage/Intropage.component';
import { OnlyNumberDirective } from './only-number.directive';
import { PatientonboardComponent } from './patientonboard.component';
import { ProfilepageComponent } from './profilepage/profilepage.component';
import { QuestionsComponent } from './questions/questions.component';
import { Questions1Component } from './questions1/questions1.component';
import { RecoverycoachComponent } from './recoverycoach/recoverycoach.component';
import { remembertempComponent } from './remembertemp/remembertemp.component';
import { SecurityComponent } from './security/security.component';
import { Security1Component } from './security1/security1.component';
import { SecurityquestionComponent } from './securityquestion/securityquestion.component';
import { SupportpageComponent } from './supportpage/supportpage.component';
import { UploadComponent } from './upload/upload.component';
import { UservalidateforCcComponent } from './uservalidatefor-cc/uservalidatefor-cc.component';
import { UservalidationComponent } from './uservalidation/uservalidation.component';
import { WelcomeComponent } from './welcome/welcome.component';
import { WelcomemailComponent } from './welcomemail/welcomemail.component';
import { WelcomepageComponent } from './welcomepage/welcomepage.component';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient, HttpClientModule } from '@angular/common/http';
export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/i18n/', '.json');  // Path to translation files
}
@NgModule({
    imports: [
        CommonModule,
        // DataTablesModule,
        AppRoutingModule,
        BsDatepickerModule.forRoot(),
        TooltipModule.forRoot(),
        FormsModule,
        MatCardModule,
        MatDialogModule,
        NgxMaskModule,
        HttpClientModule,
        TranslateModule.forRoot({
        loader: {
            provide: TranslateLoader,
            useFactory: HttpLoaderFactory,
            deps: [HttpClient]
        }
        })
    ],
    providers: [DatePipe],
    declarations: [
        PatientonboardComponent,
        CreatenewpasswordComponent,
        WelcomeComponent,
        ProfilepageComponent,
        WelcomepageComponent,
        IntropageComponent,
        UploadComponent,
        RecoverycoachComponent,
        SecurityComponent,
        Security1Component,
        CodeComponent,
        OnlyNumberDirective,
        CarepathreadyComponent,
        QuestionsComponent,
        Questions1Component,
        CreatecarepasswordComponent,
        WelcomemailComponent,
        HelpdeskComponent,
        SupportpageComponent,
        SecurityquestionComponent, UservalidationComponent,
        remembertempComponent,
        UservalidateforCcComponent
    ]
})
export class PatientonboardModule { }
